import type { PropsWithChildren } from 'react';
import { GridOverlay } from '@mui/x-data-grid-pro';
import { Stack } from '@mui/material';
import { EmptyStateIcon } from '../../../icons';

export function GridEmptyState(props: PropsWithChildren) {
  const { children } = props;

  return (
    <GridOverlay sx={{ pointerEvents: 'auto' }}>
      <Stack
        spacing={4}
        justifyContent='center'
        alignItems='center'
        data-testid='empty-state'
      >
        <EmptyStateIcon />
        {children}
      </Stack>
    </GridOverlay>
  );
}
